import { useMutation } from "@tanstack/react-query";
import {
	createManualInfraction,
	uploadInfractionAttachments,
} from "../services/infractions.service";
import type { CreateManualInfractionRequest } from "../types/infraction-api.types";

type CreateManualInfractionVariables = {
	payload: CreateManualInfractionRequest;
	attachmentFiles: { type: number; file: File }[];
};

export function useCreateManualInfraction() {
	return useMutation({
		mutationKey: ["infractions", "create-manual"],
		mutationFn: async ({
			payload,
			attachmentFiles,
		}: CreateManualInfractionVariables) => {
			const attachments = await uploadInfractionAttachments(
				payload.vehicleId,
				attachmentFiles
			);

			return createManualInfraction({
				...payload,
				attachments: attachments.length > 0 ? attachments : null,
			});
		},
	});
}
